
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Format } from '../../core/helpers/formatHelper';

@Component
export default class InputSelect extends Vue {
  @Prop() cssClass!: string;
  @Prop() id!: string;
  @Prop() options!: any;
  @Prop() required!: boolean;
  @Prop() error!: string;
  @Prop() value!: string;

  selectedValue: any = '';
  isOpen: boolean = false;

  mounted() {
    this.selectedValue = this.value;
  }

  getSelected() {
    const dom: any = document.getElementById(this.id);
    if (Format.IsNull(dom)) {
      return;
    }
    this.selectedValue = dom.value;
    return this.selectedValue;
  }

  get isDefaultSelected() {
    return this.selectedValue === '-1' || this.selectedValue === -1;
  }

  showRequiredLabel() {
    return (
      this.required === true &&
      (this.selectedValue === -1 || this.selectedValue === '-1') &&
      Format.IsNull(this.error)
    );
  }

  openDropdown() {
    this.isOpen = true;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  handleChange() {
    const selected = this.getSelected();
    this.$emit('input', selected);
    this.isOpen = false;
  }
}
